module.exports = __webpack_public_path__ + "static/Approvals_hires-f44e02cd31092c3ce735cdbb4cf83161.jpg";